/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M7 6H17"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 18V10M12 10L9.5 12.5M12 10L14.4615 12.4615M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M12 18V10M12 10L9.5 12.5M12 10L14.4615 12.4615M7 6H17M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM7 5.25C6.58579 5.25 6.25 5.58579 6.25 6C6.25 6.41421 6.58579 6.75 7 6.75H17C17.4142 6.75 17.75 6.41421 17.75 6C17.75 5.58579 17.4142 5.25 17 5.25H7ZM12.5303 9.46967C12.3897 9.32902 12.1989 9.25 12 9.25C11.8011 9.25 11.6103 9.32902 11.4697 9.46967L8.96968 11.9697C8.67679 12.2626 8.67679 12.7374 8.96968 13.0303C9.26257 13.3232 9.73745 13.3232 10.0303 13.0303L11.25 11.8107V18C11.25 18.4142 11.5858 18.75 12 18.75C12.4142 18.75 12.75 18.4142 12.75 18V11.8107L13.9312 12.9919C14.2241 13.2848 14.699 13.2848 14.9919 12.9919C15.2848 12.699 15.2848 12.2241 14.9919 11.9312L12.5303 9.46967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C7.13872 2 6.20808 2 5.45492 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9L2 14C2 16.8003 2 18.2004 2.54497 19.27C3.02434 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2V2L14.5 2M12 18V10M12 10L9.5 12.5M12 10L14.4615 12.4615M7 6H17"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M12 18V10M12 10L9.5 12.5M12 10L14.4615 12.4615M7 6H17M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.25 6C6.25 5.58579 6.58579 5.25 7 5.25H17C17.4142 5.25 17.75 5.58579 17.75 6C17.75 6.41421 17.4142 6.75 17 6.75H7C6.58579 6.75 6.25 6.41421 6.25 6ZM12 9.25C12.1989 9.25 12.3897 9.32902 12.5303 9.46967L14.9919 11.9312C15.2848 12.2241 15.2848 12.699 14.9919 12.9919C14.699 13.2848 14.2241 13.2848 13.9312 12.9919L12.75 11.8107V18C12.75 18.4142 12.4142 18.75 12 18.75C11.5858 18.75 11.25 18.4142 11.25 18V11.8107L10.0303 13.0303C9.73745 13.3232 9.26257 13.3232 8.96968 13.0303C8.67679 12.7374 8.67679 12.2626 8.96968 11.9697L11.4697 9.46967C11.6103 9.32902 11.8011 9.25 12 9.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
